import { ChangeEvent, useState } from "react";
import { Form } from "react-bootstrap";
import { useFlags } from "launchdarkly-react-client-sdk";
import type { PhaseFormValues } from "../types/Phase";
import TextField from "@components/FormsV2/TextField/TextField";
import GenericToggle from "@components/FormsV2/GenericToggle/GenericToggle";
import "./style.css";

export interface PhaseFormProps {
  id: string;
  initialValues: PhaseFormValues;
  isPersisted: boolean;
  onSubmit: (values: PhaseFormValues) => void;
  isSubmitting?: boolean;
}

export const PhaseForm = ({
  id,
  initialValues,
  isPersisted,
  onSubmit,
  isSubmitting: _isSubmitting,
}: PhaseFormProps) => {
  const { configAllLanguageTabs } = useFlags();
  const showLanguage = !!configAllLanguageTabs;
  const [values, setValues] = useState<PhaseFormValues>(initialValues);
  const update = <K extends keyof PhaseFormValues>(
    key: K,
    val: PhaseFormValues[K]
  ) => setValues((prev) => ({ ...prev, [key]: val }));

  return (
    <Form
      id={id}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(values);
      }}
    >
      <div className="row">
        <div className="col-sm-3">
          <Form.Label htmlFor="phase-name">Name</Form.Label>
          <TextField
            label={null}
            id="phase-name"
            value={values.name}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              update("name", e.target.value)
            }
            required
          />
        </div>
        {isPersisted && showLanguage && (
          <div className="col-sm-3">
            <Form.Label htmlFor="phase-sow-language">
              Service Description
            </Form.Label>
            <TextField
              label={null}
              id="phase-sow-language"
              value={values.sowLanguage}
              onChange={() => {
                /* read-only — Rails has this disabled too */
              }}
              disabled
            />
          </div>
        )}
        <div className="col-sm-3 phaseToggleCell">
          <Form.Label>Make this the default phase?</Form.Label>
          <GenericToggle
            key={`default-${initialValues.isDefault}`}
            initialValueOfIsOn={values.isDefault}
            onToggle={(v: boolean) => update("isDefault", v)}
            onText="Default"
            offText="Not default"
            hasText
          />
          <small className="text-muted">
            When checked, imported services will be assigned to this phase if no
            matching phase is found.
          </small>
        </div>
      </div>
    </Form>
  );
};
